// src/components/IntegrationsError.tsx
import React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { Card, CardBody, CardFooter, Alert, Button } from "reactstrap";

interface Props extends WithTranslation {
  error: string;
  onRetry: () => void;
}

const IntegrationsError: React.FC<Props> = ({ error, onRetry, t }) => (
  <Card className="shadow-sm border-0 rounded mx-auto my-5" style={{ maxWidth: 480 }}>
    <CardBody className="text-center py-5">
      <Alert
        color="danger"
        className="d-inline-flex align-items-start px-4 py-3 mb-4"
        style={{ borderRadius: 8 }}
      >
        <i
          className="ri-error-warning-line me-3 text-danger"
          style={{ fontSize: 28, lineHeight: 1 }}
        />
        <div className="text-start">
          <h5 className="mb-2">{t("integrations.error.title", "Oops! Something went wrong")}</h5>
          <p className="mb-0 small text-muted">{error}</p>
        </div>
      </Alert>
      <Button color="danger" onClick={onRetry} className="me-2">
        <i className="ri-restart-line me-1" /> {t("action.retry", "Retry")}
      </Button>
      <Button outline color="secondary" onClick={() => window.location.reload()}>
        <i className="ri-refresh-line me-1" /> {t("action.reload", "Reload page")}
      </Button>
    </CardBody>
    <CardFooter className="text-center text-muted small">
      {t(
        "integrations.error.contactSupport",
        "If the problem persists, please contact support."
      )}
    </CardFooter>
  </Card>
);

export default withTranslation()(IntegrationsError);
